import * as wishlistService from "../tools/wishlist-service";
import Header from "../components/header";
import LeftMenu from "../components/left-menu";
import ApartCard from "../components/apart-card";
import { useEffect, useState, useTransition } from "react";
import * as Constants from "../config";
import {checkArrayDefined, checkArrayJustDefined} from "../tools/valueshelper";
import { isMobile } from "react-device-detect";
import NothingFound from "../components/nothing-found";
import { useTranslation } from "react-i18next";
export default function Favorites(){

    const { t } = useTranslation();
    const [apartments, setApartments] = useState();     
    const[pagesCount, setPagesCount] = useState(1);
    const[currentPage,setCurrentPage] = useState(1);
    const[resultPerPage,setResultPerPage] = useState(10);
    const [pageApartments, setPageApartments] = useState([]);
    const [allAparts, setAllAparts] = useState([]);    
    const [loaded,setLoaded] = useState(false);

    function filterData(data){
        var wishlist = wishlistService.getWishList();
        console.log(wishlist);
        console.log(data);
        return data.filter(x=> wishlist.find(y=>y.id == x.id) != undefined);
    }

    function getData() {
        fetch(Constants.apiurl + Constants.apartments, Constants.requestHeaderGet())
        .then((response) => response.json())
        .then((data) => {
            setAllAparts(data);
            var filtered = filterData(data);
            setPagesCount(Math.ceil(filtered.length/resultPerPage));
            setApartments(filtered);
            setLoaded(true);
        })
        .catch((err) => {
           console.log(err.message);
        });
    }

    useEffect(() => {
        getData();
     }, []);

    useEffect(() => {
        getPageContent();
     }, [apartments]);

     function getPages(){
        var i = 1;
        var arr = [];
        while(i<=pagesCount){
            arr.push(i);
            i++;
        }
        return arr.map(x=>
            <div className={currentPage==x ? "selected-page" : ""} onClick={()=>setCurrentPage(x)}>
                {x}
            </div>
        );
     }
     
     useEffect(()=>{
        getPageContent();
     },[currentPage]);

     function goToAnchor(anchor){
        const posy = document.getElementById(anchor)?.getBoundingClientRect().top;
        document.getElementById(anchor)?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });   
        const yOffset = -160; 
        const y = posy + window.scrollY + yOffset;

        window.scrollTo({top: y, behavior: 'smooth'});
    }

     function getPageContent(){
        if(checkArrayJustDefined(apartments))
        {
            var start = (currentPage - 1)*resultPerPage;
            var end = start + resultPerPage;
            var show = apartments.slice(start,end);
            setPageApartments(show);
            goToAnchor("apart-result");        
        }
     }
     

     function setNext(){
        if(currentPage == pagesCount)
            return;
        setCurrentPage(currentPage+1);
     }
     function setPrevious(){
        if(currentPage == 1)
            return;
        setCurrentPage(currentPage-1);
     }

     function apartsList(aparts){

        return aparts.map(x=>
            <div key={x.id}>
                <ApartCard data={x}/>
            </div>
        )
     }

    return (
        <>
            <Header/>        
            <div id="page">
                {!isMobile ?
                <div className="left-menu">
                    <LeftMenu/>
                </div>
                :""}
                <div className="main-page-content">    
                
                    {loaded? 
                    <>
                        <div id="apart-result">
                            <div >
                                <div id="aparts-cards">
                                    {!!(pageApartments) && pageApartments.length > 0 ? apartsList(pageApartments) : <NothingFound/>}
                                </div>
                            </div>
                            {pagesCount > 1 ?
                                <div id="pagination">
                                        <div onClick={setPrevious}>
                                            &#60;                                
                                        </div>
                                        {
                                        getPages()  
                                        } 
                                        <div onClick={setNext}>
                                            &#62;                               
                                        </div>    
                                </div>
                                :
                                ""
                            }
                        </div>
                        
                        {/* <div id="check-other">
                                    {t('Consultez d’autres propositions')}
                                </div>
                                <div id="aparts-cards">                                
                                    
                                    {samePropertyApartsList() }
                        </div> */}
                    </>
                    :
                    <div className="loader-box">
                        <div className="loader"></div> 
                    </div>
                    }  
                 </div>
            </div>
        </>
    )
}